import { Alert } from '@ui/themed';
import type { AuthFormError } from '../types';

export function FormErrorAlert({ error }: { error: AuthFormError }) {
  return (
    <Alert variant="warning" headingLevel="h3">
      {'errors' in error ? (
        Object.values(error.errors)
          .flat()
          .map((message) => (
            <p key={message} className="text-sm">
              {message}
            </p>
          ))
      ) : (
        <p className="text-sm">{error.message}</p>
      )}
    </Alert>
  );
}
